import { throttle } from 'lodash';
import { Resizable } from 're-resizable';
import React, { useMemo } from 'react';

import styles from '../statics/styles.scss';

const Resizer = ({
  children,
  componentData,
  onResize,
  maxWidth,
  minWidth,
  onResizeStop,
  disabled,
}) => {
  const enable = {
    left: true,
    right: true,
  };

  switch (componentData.containerData?.alignment) {
    case 'LEFT':
      enable.left = false;
      break;
    case 'RIGHT':
      enable.right = false;
      break;
    default:
      break;
  }
  if (disabled) {
    enable.left = false;
    enable.right = false;
  }
  return (
    <Resizable
      data-hook="ricos-resizer"
      minWidth={minWidth}
      maxWidth={maxWidth}
      size={{ width: 'auto', height: 'auto' }}
      enable={enable}
      className={styles.resizer}
      onResize={onResize}
      onResizeStop={onResizeStop}
      handleClasses={{
        right: [styles.handlerRight, 'ricos-resize-handler-right'].join(' '),
        left: styles.handlerRight,
      }}
      handleStyles={{
        right: {
          borderRadius: '50%',
          width: 14,
          height: 14,
          zIndex: 7,
          background: `#fff`,
          border: 'solid 2px var(--ricos-action-color)',
          position: 'absolute',
          top: `calc(50% - 7px)`,
          right: -8,
        },
        left: {
          borderRadius: '50%',
          width: 14,
          height: 14,
          zIndex: 7,
          background: `#fff`,
          border: 'solid 2px var(--ricos-action-color)',
          position: 'absolute',
          top: `calc(50% - 7px)`,
          left: -8,
        },
      }}
    >
      {children}
    </Resizable>
  );
};

const ResizerHOC = Component => {
  return props => {
    const { editor, updateAttributes, componentData, selected, decorations } = props;
    const minWidth = 15;

    const editorContentWidth = useMemo(() => {
      const isBreakoutFullWidth = decorations.some(
        decoration => decoration.type?.attrs['data-breakout'] === 'fullWidth'
      );

      if (isBreakoutFullWidth) {
        return editor.view.dom.clientWidth;
      }

      const editorContent = window.getComputedStyle(editor.view.dom.firstChild);
      const paddingStart = parseInt(editorContent.paddingInlineStart) || 0;
      const paddingEnd = parseInt(editorContent.paddingInlineEnd) || 0;

      return editor.view.dom.clientWidth - paddingStart - paddingEnd;
    }, [editor.view.dom.clientWidth, decorations]);

    const maxWidth = Math.max(minWidth, editorContentWidth);

    const onResizeThrottle = throttle((event, direction, elementRef) => {
      if (Number.isInteger(parseInt(elementRef.style.width))) {
        updateAttributes({
          containerData: {
            ...props.componentData.containerData,
            width: {
              custom: parseInt(elementRef.style.width),
            },
          },
        });
      }
    }, 30);

    const onResizeStop = (_event, _direction, elementRef) => {
      updateAttributes({
        containerData: {
          ...props.componentData.containerData,
          width: {
            custom: parseInt(elementRef.style.width),
          },
        },
      });
    };

    return (
      <Resizer
        disabled={!selected}
        componentData={componentData}
        onResize={onResizeThrottle}
        maxWidth={maxWidth}
        minWidth={minWidth}
        onResizeStop={onResizeStop}
      >
        <Component {...props} />
      </Resizer>
    );
  };
};

export default ResizerHOC;
